import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import NameField from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {  formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import { Field } from 'formik';

const CallInclusionNameField = ({  darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.name && touched.name}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row"  sx={stackStyling(true)} >
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}  color={darkMode ? 'white' : 'black'}>
                        Name <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text  sx={descriptionStyling}fontSize="sm" color={darkMode ? 'gray.300' : 'gray.600'} maxWidth={250}>
                        Enter a name for this call inclusion.
                    </Text>
                </Box>
                <Box flex="1" minWidth="250px">
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '8px', marginRight: '6px'  }}>
                    <VStack width="100%" alignItems="normal">
                        <Field component={NameField}
                            id="name"
                            name="name"
                            validate={value => !value && 'Name is required'}
                            error={errors.name}
                            {...props}
                        />
                    </VStack>
                     {isHovered && (
                    <FieldToolTip
                        label="Enter a name."
                        ariaLabel="calling-rate-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
                    </Box>
                </Box>
               

            </Stack>
        </FormControl>
    );
};

export default CallInclusionNameField;
